import { Interface } from 'ethers/lib/utils'
import { BigNumber } from '@ethersproject/bignumber'
import { ChainId, DELAY_ABI, DELAY_ADDRESS, NATIVE_CURRENCY, toToken, EXECUTE_WITHDRAW_GAS_LIMIT } from '../constants'
import { CurrencyValue, Pair } from '../model'
import { Settings } from '../providers'
import { formatCurrency } from '../model'
import { getRemoveLiquidityFeeDisplay, areTokensSorted } from '../utils'
import { WithdrawInfo } from '../providers/transactions/model'

export function getRemoveLiquidityTransaction(
  account: string,
  chainId: ChainId,
  firstValue: CurrencyValue,
  secondValue: CurrencyValue,
  liquidity: BigNumber,
  gasPrice: BigNumber,
  pair: Pair,
  settings: Settings
) {
  const tokenA = toToken(firstValue.currency)
  const tokenB = toToken(secondValue.currency)
  const [token0, token1, currencyValue0, currencyValue1] = areTokensSorted(tokenA, tokenB)
    ? [tokenA, tokenB, firstValue, secondValue]
    : [tokenB, tokenA, secondValue, firstValue]
  const unwrap = firstValue.currency === NATIVE_CURRENCY[chainId] || secondValue.currency === NATIVE_CURRENCY[chainId]
  const safeGasLimit = EXECUTE_WITHDRAW_GAS_LIMIT + settings.gasLimitOverpay
  const nowSeconds = Math.floor(Date.now() / 1000)
  const safeGasPrice = gasPrice.mul(settings.gasPriceMultiplier).div(1000)
  const gasPrepay = safeGasPrice.mul(safeGasLimit)
  const txInfo = {
    type: 'WITHDRAW',
    currency0: token0.serialize(),
    currency1: token1.serialize(),
    liquidityIn: formatCurrency(18, liquidity),
    expectedValue0Out: currencyValue0.format(),
    expectedValue1Out: currencyValue1.format(),
    gasPrepay: gasPrepay.toString(),
    slippageTolerance: settings.slippageTolerance.toString(),
    fees: getRemoveLiquidityFeeDisplay(pair),
  } as WithdrawInfo
  return {
    to: DELAY_ADDRESS[chainId],
    data: new Interface(DELAY_ABI).encodeFunctionData('withdraw', [
      {
        token0: token0.address,
        token1: token1.address,
        liquidity: liquidity,
        amount0Min: BigNumber.from(0),
        amount1Min: BigNumber.from(0),
        unwrap,
        to: account,
        gasLimit: safeGasLimit,
        submitDeadline: nowSeconds + settings.submitDeadline,
        executionDeadline: nowSeconds + settings.executionDeadline,
      },
    ]),
    value: gasPrepay,
    txInfo,
  }
}
